import { CustomTextArea, CustomTextFieldNumberComponente, SingleTableBoxScene } from "@/shared/components/ui";
import { AlertSeverityEnum, EstadoOrdenTrabajoCodigoEnum, OrdenTrabajo } from "@/shared/interfaces";
import { emptyCellOneLevel, formatDateWithTimeAMPM, gridSizeMdLg12, texto, useCheckPermissions } from "@/shared";
import { useMemo, useState } from "react";
import { MRT_ColumnDef } from "material-react-table";
import { usePlanStore } from "@/store/erp/system-settings/plan.store";
import { Button, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { useForm } from "react-hook-form";
import { useUiStore } from "@/store/ui";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import { useGeographyStore } from "@/store/erp";
import TablaInstalacionAsignadaComponente from "../componente/TablaInstalacionAsignadaComponente";
import { useUpdateOrdenTrabajo } from "@/shared/actions/erp";
import { PermissionsEnum } from "@/auth/interfaces";

type IObservacionCliente = {
  id_orden_trabajo?: string;
  observacion_cliente?: string
  motivo_rechazo_cliente?: string;
  celular?: string;
}

const InstalacionAsignadaPage = () => {

  useCheckPermissions(PermissionsEnum.api_view_ordentrabajo);

  const [openModalObservacion, setOpenModalObservacion] = useState(false);
  const [openModalRechazar, setOpenModalRechazar] = useState<boolean>(false);
  const [openModalEditarCelular, setOpenModalEditarCelular] = useState<boolean>(false);
  const [disabled, setDisabled] = useState<boolean>(false);

  const sectors = useGeographyStore(s => s.sectors);
  const zones = useGeographyStore(s => s.zones);
  const plans = usePlanStore(s => s.plans);

  const setAlert = useUiStore(s => s.setAlert);
  const setIsGlobalLoading = useUiStore(s => s.setIsGlobalLoading);

  const fetchPutOrdenTrabajo = useUpdateOrdenTrabajo<OrdenTrabajo>();
  ///* form
  const form = useForm<IObservacionCliente>({
  });

  const {
    handleSubmit,
    reset,
    formState: { errors }
  } = form;

  ///* columns
  const columnsOTEspera = useMemo<
    MRT_ColumnDef<OrdenTrabajo>[]
  >(
    () => [
      /*  {
         accessorKey: 'action.rechazar',
         header: 'Rechazar',
         size: 50,
         enableColumnFilter: false,
         enableColumnOrdering: false,
         enableSorting: false,
         Cell: ({ }) => (
           <div style={{ textAlign: 'center' }}>
             <Tooltip title='Rechazar' placement="top" >
               <IconButton onClick={() => {
                 setOpenModalRechazar(true)
                 setDisabled(false);
               }}>
                 <HighlightOffIcon color="error" />
               </IconButton>
             </Tooltip>
           </div>
         )
 
       }, */
      {
        accessorKey: 'observacion_cliente',
        header: 'Observacion Cliente',
        size: 350,
        Cell: ({ row }) => (
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

            {row.original.observacion_cliente ? <>
              <Typography>
                {`${row.original.observacion_cliente.substring(0, 40)}...`}
                <Button size="small" onClick={() => {
                  setDisabled(true);
                  reset({ observacion_cliente: row.original.observacion_cliente });
                  setOpenModalObservacion(true);
                }} >{'Ver Todo'}</Button>
              </Typography>
            </> : 'N/A'}

            <Tooltip title='Ingresar una Observación' placement="top" >
              <IconButton onClick={() => {
                setDisabled(false);
                reset({ id_orden_trabajo: row.original.id_orden_trabajo, observacion_cliente: row.original.observacion_cliente ? `${row.original.observacion_cliente}\n${formatDateWithTimeAMPM(new Date)} - ` : `${formatDateWithTimeAMPM(new Date)} - ` });
                //setIdOrdenTrabajo(row.original.id_orden_trabajo);
                setOpenModalObservacion(true);
              }}>
                <EditIcon color="action" />
              </IconButton>
            </Tooltip>
          </div>
        )
      },
      {
        accessorKey: 'celular',
        header: 'Celular Cliente',
        size: 250,
        Cell: ({ row }) => (
          <div style={{ justifyContent: 'space-between', display: 'flex' }}>
            <Typography>{row.original.celular}</Typography>
            <Tooltip title='Editar el celular del cliente' placement="top" >
              <IconButton onClick={() => {

                setOpenModalEditarCelular(true);
                reset({ celular: row.original.celular, id_orden_trabajo: row.original.id_orden_trabajo });
              }}>
                <EditIcon color="action" />
              </IconButton>
            </Tooltip>
          </div>
        )
      },
      {
        accessorKey: 'prospecto_data.identificacion',
        header: 'Identificación',
        size: 210,
      },
      {
        accessorKey: 'prospecto_data.razon_social',
        header: 'Cliente',
        size: 300,
      },
      {
        accessorKey: 'contrato_data.numero_referencia',
        header: 'Núm. Contrato',
        size: 300
      },
      {
        accessorKey: 'agendamiento_data.fecha_instalacion',
        header: 'Fecha y hora de instalación',
        size: 300,
        Cell: ({ row }) => (
          `${row.original.agendamiento_data?.fecha_instalacion} ${row.original.agendamiento_data?.hora_instalacion} `
        )
      },
      {
        accessorKey: 'direccion',
        header: 'Dirección Cliente',
        size: 300,
        Cell: ({ row }) => emptyCellOneLevel(row, 'direccion'),
      },

      {
        accessorKey: 'celular_2',
        header: 'Teléfono fijo',
        size: 300,
        Cell: ({ row }) => emptyCellOneLevel(row, 'celular_2'),
      },
      {
        accessorKey: 'agendamiento_data.email',
        header: 'Correo',
        size: 300,
        Cell: ({ row }) => emptyCellOneLevel(row, 'email'),
      },

      {
        accessorKey: 'agendamiento_data.persona_referencia_nombre',
        header: 'Persona de Referencia',
        size: 300,
        Cell: ({ row }) => emptyCellOneLevel(row, 'persona_referencia_nombre'),
      },
      {
        accessorKey: 'agendamiento_data.persona_referencia_parentesco',
        header: 'Parentesco de Referencia',
        size: 300,
        Cell: ({ row }) => emptyCellOneLevel(row, 'persona_referencia_parentesco'),
      },
      {
        accessorKey: 'agendamiento_data.persona_referencia_celular',
        header: 'Celular de Referencia',
        size: 300,
        Cell: ({ row }) => emptyCellOneLevel(row, 'persona_referencia_celular'),
      },
      {
        accessorKey: 'preventa_data.plan',
        header: 'Plan',
        size: 330
      },
      {
        accessorKey: 'plan_data.velocidad_subida_maxima',
        header: 'Velocidad de internet',
        size: 300,
      },
      {
        accessorKey: 'plan_data.valor',
        header: 'Valor del plan',
        size: 300,
        Cell: ({ row }) => `$${row.original.plan_data?.valor}`,
      },
      {
        accessorKey: 'preventa_data.tipo_instalacion',
        header: 'Tipo de instalación',
        size: 300
      },
      {
        accessorKey: 'preventa_data.valor_instalacion',
        header: 'Valor de Instalación',
        size: 300,
        Cell: ({ row }) => `$${row.original.preventa_data?.valor_instalacion}`,
      },
      ///* fk
      {
        accessorKey: 'ciudad',
        header: 'Ciudad',
        size: 300,
        Cell: ({ row }) => emptyCellOneLevel(row, 'ciudad'),
      },
      {
        accessorKey: 'flota',
        header: 'Flota',
        size: 330,
        Cell: ({ row }) => row.original?.flota || 'N/A',
      },
      {
        accessorKey: 'nap',
        header: 'NAP',
        size: 300,
        Cell: ({ row }) => emptyCellOneLevel(row, 'nap'),
      },
      {
        accessorKey: 'observacion', // prospecto
        header: 'Observación 1',
        size: 300,
        Cell: ({ row }) => emptyCellOneLevel(row, 'observacion'),
      },
      {
        accessorKey: 'observacion_2', // prospecto
        header: 'Observación 2',
        size: 300,
        Cell: ({ row }) => emptyCellOneLevel(row, 'observacion_2'),
      },

      {
        accessorKey: 'vendedor',
        header: 'Asesor Venta',
        size: 200,
        Cell: ({ row }) => row.original.user_create
      }
    ],
    [zones, sectors, plans]
  );

  return (
    <>
      <SingleTableBoxScene title="Instalación Asignada">
        <TablaInstalacionAsignadaComponente
          columns={columnsOTEspera} />
      </SingleTableBoxScene>

      {/*MODAL AGREGAR UNA OBSERVACION*/}
      {openModalObservacion && (
        <ScrollableDialogProps
          open={openModalObservacion}
          title="Observacion Cliente"
          cancelTextBtn="Cancelar"
          confirmTextBtn="Confirmar"
          // actions
          onClose={() => {
            setOpenModalObservacion(false)
            reset({ observacion_cliente: '', motivo_rechazo_cliente: '' });
          }}

          onConfirm={handleSubmit(async () => {
            if (!disabled) {
              setOpenModalObservacion(false);
              setIsGlobalLoading(true);
              await fetchPutOrdenTrabajo.mutateAsync({
                id: form.getValues().id_orden_trabajo!,
                data: {
                  observacion_cliente: `${form.getValues().observacion_cliente}`
                } as any
              })
              setIsGlobalLoading(false);
              reset({ observacion_cliente: '', motivo_rechazo_cliente: '' });

              return;
            }
            setOpenModalObservacion(false);
          })}
          // content
          minWidth="48%"
          contentNode={

            <Grid container spacing={2}>

              <CustomTextArea
                disabled={disabled}
                rows={7}
                label="Observación"
                name="observacion_cliente"
                control={form.control}
                defaultValue={form.getValues().observacion_cliente || ''}
                error={form.formState.errors.observacion_cliente}
                helperText={form.formState.errors.observacion_cliente?.message}
                required={false}
              />
            </Grid>

          }
        />
      )
      }

      {/*MODAL RECHAZAR*/}
      {openModalRechazar && (
        <ScrollableDialogProps
          open={openModalRechazar}
          title="Rechazar"
          cancelTextBtn="Cancelar"
          confirmTextBtn="Confirmar"
          dialogContentText="Estas a punto de rechazar una venta ¿Estas seguro de rechazar, esta acción es irreversible?"
          // actions
          onClose={() => {
            setOpenModalRechazar(false);
            reset({ observacion_cliente: '', motivo_rechazo_cliente: '' });
          }}
          onConfirm={handleSubmit(async () => {
            setOpenModalRechazar(false);
            setIsGlobalLoading(true);
            await fetchPutOrdenTrabajo.mutateAsync({
              id: form.getValues().id_orden_trabajo!,
              data: {
                motivo_rechazo_vendedor: `${form.getValues().motivo_rechazo_cliente}`,
                estado_orden_trabajo: EstadoOrdenTrabajoCodigoEnum.RECHAZADA
              } as any
            }
            )

            reset({ observacion_cliente: '', motivo_rechazo_cliente: '' });
            setIsGlobalLoading(false);

            return;
          })}
          // content
          minWidth="48%"
          contentNode={
            <Grid container spacing={2}>
              <CustomTextArea
                disabled={disabled}
                rows={4}
                label="Motivo de Rechazo"
                name="motivo_rechazo_cliente"
                control={form.control}
                defaultValue={form.getValues().motivo_rechazo_cliente || ''}
                error={form.formState.errors.motivo_rechazo_cliente}
                helperText={form.formState.errors.motivo_rechazo_cliente?.message}
                required={false}
              />


            </Grid>
          }
        />
      )

      }

      {/*MODAL CAMBIAR EL CELULAR DEL CLIENTE*/}
      {openModalEditarCelular && (
        <ScrollableDialogProps
          open={openModalEditarCelular}
          title="Editar Celular"
          cancelTextBtn="Cancelar"
          confirmTextBtn="Confirmar"
          dialogContentText="Estas a punto de cambiar el celular del cliente"
          // actions
          onClose={() => {
            setOpenModalEditarCelular(false);
            reset({ observacion_cliente: '', motivo_rechazo_cliente: '', celular: '' });
          }}
          onConfirm={handleSubmit(async () => {


            if (form.getValues().celular?.length === 10) {
              setOpenModalEditarCelular(false);
              setIsGlobalLoading(true);
              await fetchPutOrdenTrabajo.mutateAsync(
                {
                  id: form.getValues().id_orden_trabajo!,
                  data: {
                    celular: form.getValues().celular
                  } as any
                })
              reset({ celular: '' });
              setIsGlobalLoading(false);
              return;
            }

            setAlert(true, 'Ingresar un número valido', AlertSeverityEnum.error);
          })}
          // content
          minWidth="48%"
          contentNode={
            <Grid container spacing={2}>
              <CustomTextFieldNumberComponente
                size={gridSizeMdLg12}
                type={TiposTextFieldNumberEnum.CELULAR}
                label={texto.celular}
                error={errors.celular}
                helperText={errors.celular?.message}
                control={form.control}
                name="celular"
                defaultValue={form.getValues().celular || ''}
              />
            </Grid>
          }
        />
      )

      }

    </>

  );

}

export default InstalacionAsignadaPage;